export const GET_ALL_PROJECTS_REQUEST = 'GET_ALL_PROJECTS_REQUEST';
export const GET_ALL_PROJECTS_SUCCESS = 'GET_ALL_PROJECTS_SUCCESS';
export const GET_ALL_PROJECTS_ERROR = 'GET_ALL_PROJECTS_ERROR';
export const CANCEL_GET_ALL_PROJECTS = 'CANCEL_GET_ALL_PROJECTS';

export const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_ERROR = 'GET_PROJECTS_ERROR';

export const ADD_PROJECT_REQUEST = 'ADD_PROJECT_REQUEST';
export const ADD_PROJECT_SUCCESS = 'ADD_PROJECT_SUCCESS';
export const ADD_PROJECT_ERROR = 'ADD_PROJECT_ERROR';

export const IMPORT_PROJECT_REQUEST = 'IMPORT_PROJECT_REQUEST';
export const IMPORT_PROJECT_SUCCESS = 'IMPORT_PROJECT_SUCCESS';
export const IMPORT_PROJECT_ERROR = 'IMPORT_PROJECT_ERROR';

export const CLONE_PROJECT_REQUEST = 'CLONE_PROJECT_REQUEST';
export const CLONE_PROJECT_SUCCESS = 'CLONE_PROJECT_SUCCESS';
export const CLONE_PROJECT_ERROR = 'CLONE_PROJECT_ERROR';

export const TOGGLE_PROJECTS_GRID = 'TOGGLE_PROJECTS_GRID';

export const UPDATE_PROJECTS_PAGINATION_PARAMS =
  'UPDATE_PROJECTS_PAGINATION_PARAMS';
export const RESET_PROJECTS_PAGINATION_PARAMS =
  'RESET_PROJECTS_PAGINATION_PARAMS';
